import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['createTrip'],
});

export const createTripApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    checkReturnPlace: builder.query({
      query: (payload) => ({
        url: `return_place/`,
        method: 'POST',
        body: payload,
      }),
    }),
    createGenarateCombineCode: builder.mutation({
      query: () => ({
        url: `create_trip/combine_code/`,
        method: 'POST',
      }),
    }),
    findCreateTripAllBzps: builder.query({
      query: () => `create_trip/bzps/`,
      providesTags: ['createTrip'],
    }),
    findAllDiagramOwner: builder.query({
      query: () => `create_trip/diagram_owner/`,
      providesTags: ['createTrip'],
    }),
    findAllLocationFromTo: builder.query({
      query: () => `create_trip/location_from_to/`,
      providesTags: ['createTrip'],
    }),
    findCreateTripByTypes: builder.query({
      query: (id) => `create_trip/trailer_type/?company_id=${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'createTrip', id: result.id }]
          : ['createTrip'];
      },
    }),
    findCreateTripByTripType: builder.query({
      query: (id) => `create_trip/trailer_type/?company_id=${id}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'createTrip', id: result.id }]
          : ['createTrip'];
      },
    }),
    findCreateTripByDraftDispatchBoard: builder.query({
      query: (payload) =>
        `create_trip/draft_dispatch_board/?job_code=${payload.id}&working_day=${payload.working_day}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'createTrip', id: result.id }]
          : ['createTrip'];
      },
    }),

    findCreateTripById: builder.query({
      query: (id) => `create_trip/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'createTrip', id: result.id }]
          : ['createTrip'];
      },
    }),

    findCreateTripByDispatchBoard: builder.query({
      query: (id) => `create_trip/dispatch_board/${id}/`,
      providesTags: ['createTrip'],
    }),

    findTripTypes: builder.query({
      query: (payload) => {
        let url = `categories/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['createTrip'],
    }),

    // findGetETA: builder.query({
    //   query: (payload) => {
    //     let url = `create_trip/getETA/`;
    //     const params = [];
    //     // loop over payload entries, and expand any arrays into params array
    //     Object.entries(payload).forEach(([key, value]) => {
    //       if (value != null) {
    //         if (Array.isArray(value)) {
    //           params.push(...value.map((v) => [key, v]));
    //         } else {
    //           params.push([key, value]);
    //         }
    //       }
    //     });
    //     // construct query params using URLSearchParams
    //     const searchParams = new URLSearchParams(params);
    //     return { url: `${url}?${searchParams.toString()}` };
    //   },
    //   keepUnusedDataFor: 0,
    //   // providesTags: ['createTrip'],
    // }),
    findGetETA: builder.mutation({
      query: (payload) => ({
        url: `create_trip/getETA/`,
        method: 'POST',
        body: payload,
      }),
    }),

    findOperationLeadtimes: builder.query({
      query: (payload) => {
        let url = `operation_leadtimes/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['createTrip'],
    }),
    findRouteSpeedDistance: builder.query({
      query: (payload) => {
        let url = `route_speed_distance/distance_farthest/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null || value !== undefined) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
    }),
    checkButton: builder.query({
      query: (payload) => ({
        url: `create_trip/check_button/`,
        method: 'POST',
        body: payload,
      }),
    }),

    createGenarateJobCode: builder.mutation({
      query: (payload) => ({
        url: `create_trip/job_code/`,
        method: 'POST',
        body: payload,
      }),
    }),

    createTripSave: builder.mutation({
      query: (payload) => ({
        url: `create_trip/dispatch_board/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['DispatchBoard'],
    }),
    createTripDraft: builder.mutation({
      query: (payload) => ({
        url: `create_trip/draft_dispatch_board/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['createTrip'],
    }),

    findCurrentTimeCreateTrip: builder.query({
      query: () => `server_time/`,
      keepUnusedDataFor: 0,
      providesTags: ['createTrip'],
    }),

    updateCreateTrip: builder.mutation({
      query: (create_trip) => ({
        url: `create_trip/${create_trip.id}/`,
        method: 'PATCH',
        body: create_trip,
      }),
      invalidatesTags: ['createTrip'],
    }),
    upsertCreateTrip: builder.mutation({
      query: (create_trip) => ({
        url: `create_trip/upsert/`,
        method: 'POST',
        body: create_trip,
      }),
      invalidatesTags: ['createTrip'],
    }),
    deleteSaveDraftCreateTrip: builder.mutation({
      query: (payload) => ({
        url: `create_trip/draft_dispatch_board/delete/?job_code=${payload.id}&working_day=${payload.working_day}`,
        method: 'PUT',
      }),
      invalidatesTags: ['createTrip'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindCreateTripAllBzpsQuery,
  useFindAllDiagramOwnerQuery,
  useFindAllLocationFromToQuery,
  useFindCreateTripByIdQuery,
  useFindCreateTripByDispatchBoardQuery,
  useFindCreateTripByTypesQuery,
  useCreateGenarateJobCodeMutation,
  useFindCurrentTimeCreateTripQuery,
  useDeleteSaveDraftCreateTripMutation,
} = createTripApi;
